<!--~
  ~ Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
  ~ to an End-User License Agreement included in a separate file named EULA.txt
  ~ that is distributed with this file.
  -->
<ng-container *ngIf="dataSource?.hasHtml$ | async; then htmlTemplate; else dataTemplate"></ng-container>

<ng-template #htmlTemplate>
    <div class="selectable-text" fxLayout="column" fxLayoutAlign="space-between start" fxFlex="1 1 auto"
         [innerHTML]="dataSource?.reportHtml"></div>
</ng-template>

<ng-template #dataTemplate>
    <div class="selectable-text" fxLayout="column" fxLayoutAlign="start stretch" fxFlex="1 1 auto">

        <div class="detail-table-container">
            <table mat-table [dataSource]="dataSource">
                <ng-container matColumnDef="label">
                    <th mat-header-cell *matCellDef="let row">{{ row.label }}</th>
                </ng-container>

                <ng-container matColumnDef="value">
                    <td mat-cell *matCellDef="let row">
                        <ng-container *ngIf="tableEditActive">
                            <dash-gis-base-field [fieldDefinition]="row.field" [rowData]="row"
                                           [tableEditActive]="true"
                                           [dataFormGroup]="dataFormGroup"
                                           [dataForm]="dataForm"></dash-gis-base-field>
                        </ng-container>
                        <ng-container *ngIf="!tableEditActive">
                            <dash-gis-base-field [fieldDefinition]="row.field" [rowData]="row"
                                           [tableEditActive]="false"></dash-gis-base-field>
                        </ng-container>
                    </td>
                </ng-container>

                <tr mat-row *matRowDef="let rowData; columns: columnsToDisplay"></tr>
            </table>
        </div>
    </div>
</ng-template>
<div #attributions></div>
